import React, { Component } from 'react';

import { MyInput } from '../elements/MyInput';
import {GhoreTable} from '../tables/ghore/GhoreTable'
import {GhorePrizePage} from './GhorePrizePage'


export class GhoreKeshiDetail extends Component {
  

  constructor(props) {
    super(props);
    this.state = { currentCount: 0  ,isLoading:false};
    this.state.data = {};
    //  this.incrementCounter = this.incrementCounter.bind(this);
    this.onFormChange = this.onFormChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
    this.onPrizeClick=this.onPrizeClick.bind(this);

    



    var token = localStorage.getItem('token');
    this.headers =
    {
            'Content-Type': 'application/json',
            'AuthorizationToken':token
    };
  }

  onPrizeClick(e)
  {

    this.state.mode="prize";
    this.state.ghoreId=e;
    this.setState({});

  }
  handleSubmit(e) {
    e.preventDefault();

    var data = this.state.data;
    console.log(data);

    this.setState({isLoading:true});

    fetch('api/v1/AddGhore',
      {
        method: 'POST',
        body: JSON.stringify(data),
        headers: this.headers
      }).then(res => {
        this.status = res.status;

        res.json().then((result) =>
         {
           alert('OK');
           this.setState({isLoading:false});
           this.setState({});
        },
          (error) => {
            this.setState({isLoading:false});
          }
        );
      }
      );


  }
  onFormChange() {

  }

  handleTextChange(e, key)
  {
 //   console.log(e);
    this.state.data[key] = e;
    this.setState({});
  }





  render() 
  {
    if(this.state.isLoading)
    {
      return <div>...</div>
    }

    if(this.state.mode=="prize")
    {
      return (<GhorePrizePage ghoreId={this.state.ghoreId}></GhorePrizePage>)
    }
    return (
      <div>
        <h1>انجام قرعه کشی</h1>
      
        <br></br>


        <GhoreTable  onPrizeClick={this.onPrizeClick}>
          
        </GhoreTable>



        
        <div className="col-md-3">

        <form className="" onSubmit={this.handleSubmit} ref="myRef">
          <MyInput onChange={this.handleTextChange}  label="عنوان" name="Name" ></MyInput>
          <MyInput onChange={this.handleTextChange}  label="توضیحات" name="Description" ></MyInput>
          <button className="btn btn-primary" onClick={this.handleSubmit}>اضافه کردن</button>
        </form>

         
        </div>

     
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GhoreKeshiDetail.js